import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allProfiles } from 'app/mocks/data/users/profiles'

import { api } from 'app/utils/constants'

import { Profile } from 'app/types/users/profile'

export const getProfile = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.profiles.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const profileFound = allProfiles.find(
            (profile) => profile.id.toString() === id,
        )

        // Not found
        if (!profileFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Profile>(profileFound)
    },
)
